import { render, staticRenderFns } from "./TheProfileMenu.vue?vue&type=template&id=1903c4d4&scoped=true&"
import script from "./TheProfileMenu.vue?vue&type=script&lang=js&"
export * from "./TheProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileMenu.vue?vue&type=style&index=0&id=1903c4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1903c4d4",
  null
  
)

export default component.exports